import { Modal, Tooltip } from '@mui/material';
import { Close } from '@mui/icons-material';
import React, { useMemo } from "react";
import styled from "styled-components";
import COLOR from "utils/constants/color";

const SelectDiffernation = ({
  open,
  onClose,
  data,
  selectedData,
  handleSelectedDataForDiffernation,
}) => {
  const selectedId = useMemo(() => {
    return selectedData?.map((element) => element?.id || "") || [];
  }, [selectedData]);

  return (
    <Modal open={open} onClose={onClose} className="modal-for-rubric">
      <ModalContent orientation={window.screen.orientation}>
        <div className="flex items-center w-full justify-between">
          <SelectRubricText className="text-center">
            Select Differentiation
          </SelectRubricText>
          <CloseButton>
            <Close
              className="cursor-pointer"
              onClick={() => {
                onClose();
              }}
            />
          </CloseButton>
        </div>
        <ViewContainer className="mt-10px">
          {data?.length === 0 && (
            <div className="bubbleNotesNoData text-blue-10">
              No data available
            </div>
          )}
          {data &&
            data?.map((element, index) => (
              <ListView
                onClick={() => {
                  if (!selectedId?.includes(element.id)) {
                    return;
                  }
                  handleSelectedDataForDiffernation(element.id);
                }}
                key={index}
                className="cursor-pointer"
                disabled={!selectedId?.includes(element.id)}
                style={{
                  backgroundColor: !selectedId?.includes(element.id)
                    ? COLOR.green300
                    : "",
                  color: !selectedId?.includes(element.id) ? "white" : "",
                }}
              >
                <AssignmentName>
                  {element?.group_name?.length > 80 ? (
                    <Tooltip
                      title={element?.group_name}
                      getPopupContainer={(trigger) => trigger.parentNode}
                    >
                      {element?.group_name?.slice(0, 80) + "..."}
                    </Tooltip>
                  ) : (
                    element?.group_name
                  )}
                </AssignmentName>
                <AssignmentAndPoint>
                  {/* {data?.rubrics_meta?.length} criteria */}
                </AssignmentAndPoint>
              </ListView>
            ))}
        </ViewContainer>
      </ModalContent>
    </Modal>
  );
};

export default SelectDiffernation;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgb(204, 80, 71);
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1;
`;

const AssignmentAndPoint = styled.div`
  color: rgb(95, 99, 104);
  font-family: Roboto, Arial, sans-serif;
  line-height: 1rem;
  font-size: 0.75rem;
  letter-spacing: 0.025em;
  font-weight: 400;
`;

const AssignmentName = styled.div`
color: rgb(60, 64, 67);
    font-family: Roboto, Arial, sans-serif;
    line-height: 1.5rem;
    font-size: 1rem;
    letter-spacing: .00625em;
    font-weight: 400;
}
`;

const ListView = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 0 8px 8px;
  border-radius: 8px;
`;

const ViewContainer = styled.div`
  height: 100%;
  outline: none;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const TitleText = styled.div`
  display: flex;
  flex: 1 0 536px;
  flex-direction: column;
  overflow: hidden;
  padding-right: 24px;
`;

const TitleContainer = styled.div`
  color: rgb(95, 99, 104);
  font-family: Roboto, Arial, sans-serif;
  line-height: 1rem;
  font-size: 0.75rem;
  letter-spacing: 0.025em;
  font-weight: 400;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: row;
  padding: 8px 0 8px 8px;

  // margin-top: 20px;
`;

const Button = styled.button`
  background: none;
  border: none;
  outline: none;
  padding: none;
`;

const SelectRubricText = styled.div`
  color: rgb(32, 33, 36);
  font-family: "Google Sans", Roboto, Arial, sans-serif;
  line-height: 1.75rem;
  font-size: 1.375rem;
  letter-spacing: 0;
  font-weight: 400;
`;

const ModalContent = styled.div`
  background-color: white;
  border-radius: 8px;
  padding-bottom: 24px;

  padding-top: 20px;

  position: relative;
  width: ${(props) => (props.orientation === "landscape" ? "90%" : "100%")};
  height: ${(props) => (props.orientation === "landscape" ? "80%" : "100%")};
  box-sizing: border-box;

  max-width: 720px;
  padding: 1.5rem 1.5rem;
  max-height: 600px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (max-width: 425px) {
    padding: 5px;
  }
`;

const MenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
  //   justify-content: space-between;
  width: 100%;
  min-height: 50px;
  border-radius: 12px;
  //   border: 2px solid ${COLOR.black100};
  //   background-color: ${COLOR.blueish400};
  margin-top: ${(p) => (p.top ? p.top : "50px")};
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 2px 0px;
  flex-wrap: wrap;
`;

const MenuBtn = styled.button`
  background-color: white;
  border-top: none;
  border-left: none;
  border-right: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  outline: none;
  transition: all 300ms ease;
  padding: 2px 16px 10px 16px;
  min-width: 150px;
  margin-right: 2px;
  margin-left: 2px;
  @media (max-width: 992px) {
    margin-top: 10px;
  }
`;